<template>
  <div :class="formClass ? 'form-button' : ''" id="game-button">
    <button class="user-button" type="submit" @click.prevent="startClick()" :disabled="disabled">
      <slot></slot>
    </button>
  </div>
</template>
<script>
export default {
  name: "GameButton",
  props: {
    "form-class": {
      type: Boolean,
      default: true,
    },
    'disabled': {
      type: Boolean,
      default: false
    }
  },
  methods: {
    startClick() {
      this.$emit("clicked");
    },
  },
};
</script>
<style>
@import "../assets/css/app.css";
.user-button:disabled {
  background-color: rgb(74, 74, 74);
}
</style>
